module.exports = __webpack_public_path__ + "img/topimg.f197c65.png";